import { useState, useEffect } from "react";
import { BiSkipNext, BiSkipPrevious } from 'react-icons/bi'
import { BsZoomIn, BsZoomOut } from 'react-icons/bs'
import { Document, Page } from 'react-pdf/dist/umd/entry.webpack';

import './../css/pdf.css'


const Pdf = ({ url, togglePdf, runningInApp }) => {
    // pdf states
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [zoomLevel, setZoomLevel] = useState(1.0);
    const [, setOrientation] = useState('portrait');
    const [, setPdfContainerHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleOrientation = () => {
            const newOrientation = window.innerHeight > window.innerWidth
                ? "portrait"
                : "landscape";
            setOrientation(newOrientation);
            //prüfe pdf-container das Attribut "active" hat - also vollbild ist
            if (document.querySelector('.pdf-container').hasAttribute('active')) {
                setTimeout(() => {
                    changeHeightPdfContainer();
                }, 1000); // kurz warten, damit die Höhe korrekt gesetzt wird
            }
        };

        // modernen Screen-Orientation-API nutzen, sonst auf resize zurückfallen
        if (window.screen.orientation && window.screen.orientation.addEventListener) {
            window.screen.orientation.addEventListener('change', handleOrientation);
        } else {
            window.addEventListener('resize', handleOrientation);
        }

        // initial auslösen
        handleOrientation();

        return () => {
            if (window.screen.orientation && window.screen.orientation.removeEventListener) {
                window.screen.orientation.removeEventListener('change', handleOrientation);
            } else {
                window.removeEventListener('resize', handleOrientation);
            }
        };
    }, []);  // leeres Array: Effekt läuft nur einmal

    function changeHeightPdfContainer() {
        const viewportHeight = window.innerHeight;
        //setOrientation(viewportHeight);
        const headerContainer = document.querySelector('.header_cmeducation');
        const headerHeight = headerContainer.offsetHeight;
        const newHeight = viewportHeight - headerHeight;
        setPdfContainerHeight(newHeight);
        const pdfContainer = document.querySelector('.pdf-container');
        const mainPdf = pdfContainer.querySelector('#main-pdf');
        console.log('-> changeHeightPdfContainer to:', newHeight);
        pdfContainer.style = `height: ${newHeight}px;`;
        mainPdf.style = "height: 100%;"
    }


    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    function goToPage(targetPage) {
        if (targetPage >= 1 && targetPage <= numPages) {
            setPageNumber(targetPage);
        }
    }

    return (
        <>
            {(runningInApp) ?
                <>
                    {/* document */}
                    <div id="main-pdf" className="app-version">
                        <div id="pdf-document">
                            <Document
                                file={url}
                                onLoadSuccess={onDocumentLoadSuccess}
                                // "canvas", "svg" or "none"
                                renderMode="canvas"
                            >

                                <Page scale={zoomLevel} pageNumber={pageNumber} />
                            </Document>
                        </div>
                    </div>

                    {/* pdf controlls */}
                    <div className="pdf-nav">

                        <button className="pdf-nav-btn" onClick={() => goToPage(pageNumber - 1)} style={(pageNumber <= 1) ? { opacity: 0 } : {}}><BiSkipPrevious /> Seite zurück</button>
                        <span className="pdf-page-number" >Seite {pageNumber} von {numPages}</span>
                        <button className="pdf-nav-btn" onClick={() => goToPage(pageNumber + 1)} style={(pageNumber >= numPages) ? { opacity: 0 } : {}}>Seite weiter <BiSkipNext /></button>
                    </div>

                    <div className="pdf-zoom">
                        <div onClick={() => setZoomLevel(zoomLevel + 0.1)}><BsZoomIn /></div>
                        <div onClick={() => setZoomLevel(zoomLevel - 0.1)}><BsZoomOut /></div>
                    </div>
                </>
                :
                <iframe id="main-pdf" title="PDF-Dokument" src={url} />
            }


            <div className="pdf-toggle">
                <div className="btn-container resize-pdf-grow" onClick={togglePdf}></div>
                <div style={{ clear: "both" }}></div> {/* give container a height */}
            </div>

        </>
    )
}

export default Pdf
